import mediator from "@tvg/mediator";
import { get } from "lodash";
import { track } from "../../amplitude";
import { MediatorEventType, EventData, EventProps } from "./types";
import { EVENT_NAME } from "./constants";
import { BaseEventProps } from "../../types";

export default () => {
  mediator.base.subscribe(MediatorEventType.LOGOUT_BUTTON_CLICKED, () =>
    track<BaseEventProps>(EVENT_NAME.LOGOUT_BUTTON_CLICKED, {})
  );

  mediator.base.subscribe(
    MediatorEventType.LOGOUT_PROCESS_INITIATED,
    (data: EventData) =>
      track<EventProps>(EVENT_NAME.LOGOUT_PROCESS_INITIATED, {
        [BaseEventProps.LOGGED_OUT_BY]: get(data, "payload.loggedOutBy")
      })
  );
};
